// Studyo Today Backend
// Package studyo.today.google_calendar.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/google_calendar/v1/resources/calendar.proto (package studyo.today.google_calendar.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/google_calendar/v1/resources/calendar.proto.
 */
export const file_studyo_today_google_calendar_v1_resources_calendar = /*@__PURE__*/
  fileDesc("CjhzdHVkeW8vdG9kYXkvZ29vZ2xlX2NhbGVuZGFyL3YxL3Jlc291cmNlcy9jYWxlbmRhci5wcm90bxIpc3R1ZHlvLnRvZGF5Lmdvb2dsZV9jYWxlbmRhci52MS5yZXNvdXJjZXMiZAoIQ2FsZW5kYXISGgoSZ29vZ2xlX2NhbGVuZGFyX2lkGAEgASgJEhgKEHRvZGF5X3BsYW5uZXJfaWQYAiABKAkSDQoFdGl0bGUYAyABKAkSEwoLaXNfc2VsZWN0ZWQYBCABKAhCMKoCLVN0dWR5by5Ub2RheS5Hb29nbGVDYWxlbmRhci5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the message studyo.today.google_calendar.v1.resources.Calendar.
 * Use `create(CalendarSchema)` to create a new message.
 */
export const CalendarSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_google_calendar_v1_resources_calendar, 0);

